const Util = require('./util')
// 函数节流
function _throttle(dom, option, action, cb, context) {
  let timeout = null
  let data = {
    index: -1
  }
  // context = context || this
  const runCallback = function () {
    action(dom, option, cb, data)
    timeout = false
  }
  // 第一次
  action(dom, option, cb, data)
  return function () {
    if (timeout) {
      return
    }
    timeout = setTimeout(runCallback, option.delay)
  }
}

// 判断是否需要继续查找
function _validate(containerRect, childDom, option, data) {
  let currentDomRect

  if(option.maxOnly && data.index > -1 && data.index < childDom.length) {
    currentDomRect = childDom[data.index].getBoundingClientRect()

    if(option.direction == 'vertical' && currentDomRect.top >= containerRect.height) {// 垂直滚动
      return false
    } else if(option.direction == 'horizontal' && currentDomRect.left >= containerRect.width) {// 水平滚动
      return false
    }
  }
  return true
}

// 这里获取该dom被曝光的子组件位置，从0开始
// 最影响性能的地方
function _action(dom, option, cb, data) {
  if(!dom || !Util.checkInView(dom)) {
    return
  }
  const childDom = dom.getElementsByClassName(option.childClassName)
  const length = childDom.length
  if(length === 0) {
    return false
  }
  
  const firstChildDomRect = childDom[0].getBoundingClientRect()
  // 增加间隔，减少比对次数
  const interval = 3
  let index, i, minPos = null, maxPos = null
  const containerRect = getClientRect(option.el)

  if(!_validate(containerRect, childDom, option, data)) {
    cb(data)
    return
  }

  // 根据第一个字节点的大小，粗略计算滚动的位置
  if(option.direction == 'vertical') {// 垂直滚动
    index = parseInt((containerRect.height - firstChildDomRect.top) / firstChildDomRect.height)
  } else {// 水平滚动
    index = parseInt((containerRect.width - firstChildDomRect.left) / firstChildDomRect.width)
  }
  // 处理超出长度的情况
  index = index >= length ? (length - 1) : index
  i = index
  
  while(i >= 0 && i < length) {
    currentDomRect = childDom[i].getBoundingClientRect()
    // index往前找
    if(
      (option.direction == 'vertical' && currentDomRect.top >= containerRect.height)
      ||
      (option.direction == 'horizontal' && currentDomRect.left >= containerRect.width)
      ) {
      maxPos = i
      i = i - interval
    } else {// index往后找
      minPos = i
      i = i + interval
    }
    if (minPos != null && maxPos != null) {
      break
    }
  }
  minPos = minPos || 0
  maxPos = maxPos || length
  // 从minPos和maxPos找到最终的滚动位置
  for (i = maxPos - 1; i >= minPos; i--) {
    if(Util.checkInView(childDom[i])) {
      break
    }
  }
  data.index = i
  cb(data)
}

function getClientRect(el) {
  if(el == window) {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    }
  } else {
    return el.getBoundingClientRect()
  }
}


function checkConfig(dom, option) {
  if(!dom || !dom.getBoundingClientRect) {
    return false
  }
  if(!option.childClassName) {
    console.error('错误配置：option中必须传入childClassName属性！')
    return false
  }
  return true
}

/**
* option配置参数表：
* childClassName 子节点class name
* direction 滚动的方向，默认为垂直方向
* delay 延迟处理时间
* maxOnly 只取最大
*/
function getScrollingPosition(dom, option = {}, cb) {
  if(!checkConfig(dom, option)) {
    return
  }
  option.el = option.el || window
  option.direction = option.direction || 'vertical'
  option.delay = option.delay || 200
  // 滚动
  option.el.addEventListener('scroll', _throttle(dom, option, _action, cb))
	
}

module.exports = getScrollingPosition



// WEBPACK FOOTER //
// ./~/@dp/util-m-view-push/src/getScrollingPosition.js